export default __webpack_public_path__ + "static/media/chicken-blue.74b1097a.svg";